import { Component, Inject, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import {
  XrefColumnInfo,
  XrefColumnType,
} from '../../../Xrefs/xref-display/xrefDisplayColumns';

@Component({
  selector: 'app-search-column-dialog',
  templateUrl: './results-column-dialog.component.html',
  styleUrls: ['./results-column-dialog.component.scss'],
  standalone: false,
})
export class ResultsColumnDialogComponent implements OnInit {
  allSelected: boolean;
  visibleColumnCount: number;
  MAXSELECTED: number = 18;
  inputColumns: XrefColumnInfo[];
  outputColumns: XrefColumnInfo[];
  otherColumns: XrefColumnInfo[];

  constructor(
    public dialogRef: MatDialogRef<ResultsColumnDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { cols: XrefColumnInfo[]; maxCols: number },
  ) {
    this.inputColumns = this.data.cols.filter(v => {
      return v.columnType == XrefColumnType.FROM;
    });
    this.outputColumns = this.data.cols.filter(v => {
      return v.columnType == XrefColumnType.TO;
    });
    this.otherColumns = this.data.cols.filter(v => {
      return v.columnType == XrefColumnType.OTHER;
    });
    this.MAXSELECTED = data.maxCols;
  }

  ngOnInit(): void {
    this.countVisibleColumns();
  }

  countVisibleColumns(): void {
    this.visibleColumnCount = this.data.cols.filter(v => {
      return v.visible;
    }).length;
  }

  selectDefaults(): void {
    this.data.cols.forEach(d => {
      d.visible = d.defaultVisible;
    });
    this.countVisibleColumns();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  selectionChange(e: MatCheckboxChange, col: XrefColumnInfo): void {
    col.visible = !!e.checked;
    this.countVisibleColumns();
  }
}
